module.exports = __webpack_public_path__ + "static/media/pyramid.988e897d.webp";